import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=635a0c3f&scoped=true"
import script from "./connections.vue?vue&type=script&lang=ts"
export * from "./connections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a0c3f",
  null
  
)

export default component.exports